<template>
  <div id="app">
    <el-container>
      <el-header height="150px">
        <div class="header">
          <img class="header_logo" src="../../../assets/home/home_purchase/yhyj3_03.png"/>
        </div>
      </el-header>
      <el-main>
        <div class="main">
          <div class="main_corlo">
            <div class="main_shangpin">

              <img class="main_shangpin_img" :src="url+'/storage/'+list_xinxi.goods[0].cover"/>
              <span class="shanpin_bianhao">订单编号: {{ list_xinxi.code }}</span>
              <span class="shanpin_name">{{ list_xinxi.goods[0].goods_name }}</span>
              <div class="shanpin_jine">{{list_xinxi.total}}<span style="color:black">元</span></div>
              <!--            <div class="shangpin_daojishi">请在4天23时59分 内完成支付</div>-->
            </div>
          </div>
          <div>
            <template v-if="btndisabled">
              <div class="inputStyle">
                <el-input placeholder="请输入支付密码" v-model="password" type="password"></el-input>
              </div>
              <el-button class="btnstyle1" type="info" @click="balance_payment">
              支付
              </el-button>
            </template>
            <a href="/user.html#/trans/purchase" v-else>
              <el-button class="btnstyle2" type="info">
                已完成支付
              </el-button>
            </a>
          </div>
          <!--          <div class="main_biaoti">支付{{list_xinxi.total}}(元)</div>-->
          <!--          <div class="main_jine">{{list_xinxi.total}}</div>-->
          <!--          <div style="width: 100%;-->
          <!--    margin: 10px auto;-->
          <!--    text-align: center;">-->
          <!--            &lt;!&ndash;            <div>&ndash;&gt;-->
          <!--            &lt;!&ndash;              <div id="qrcode" align="center" style="margin-top: 54px;margin-bottom: 70px"></div>&ndash;&gt;-->
          <!--            &lt;!&ndash;            </div>&ndash;&gt;-->
          <!--            &lt;!&ndash;            <el-button v-if="pay_status!=1" type="primary" style="margin-top: 40px" @click="api_data">已付款</el-button>&ndash;&gt;-->

          <!--            &lt;!&ndash;            <img style="margin: 0 auto " src="../../../assets/home/home_purchase/cbf0d3c16de385d69185deb18247564.png"/>&ndash;&gt;-->
          <!--            <a @click="fukuan_shijian=true">-->
          <!--              <div style="margin: 10px auto;width: 428px;height: 80px; background: #EF4F3F;-->
          <!--    border-radius: 5px;-->
          <!--    text-align: center;-->
          <!--    line-height: 80px;-->
          <!--    font-size: 25px;-->
          <!--    font-family: Source Han Sans CN;-->
          <!--    font-weight: 500;-->
          <!--    color: #FFFFFF;">已完成支付-->
          <!--              </div>-->
          <!--            </a>-->
          <!--          </div>-->
          <el-dialog
                  title="提示"
                  :visible.sync="fukuan_shijian"
                  width="30%"
          >
            <span>是否跳转到用户页</span>
            <span slot="footer" class="dialog-footer">
    <el-button @click="fukuan_shijian = false">取 消</el-button>
              <a href="user.html#/trans/purchase">
    <el-button type="primary" @click="fukuan_shijian = false">确 定</el-button>
                </a>
  </span>
          </el-dialog>

        </div>
        <div style="width: 100%;height: 200px"></div>
      </el-main>
      <el-footer height="250px">
        <el-row class="footer footer_bottom">
          <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
            <div class="footer_width">
              <div class="glzy_top">
                <a class="xuanzhong wenzi" href="">
                  <span class="footer_text2 footer_gyyyj_left">关于仪海仪家</span>
                </a>
                <a class="xuanzhong wenzi" href="">
                  <span class="footer_text2 footer_lxwm_left">联系我们</span>
                </a>
                <a class="xuanzhong wenzi" href="">
                  <span class="footer_text2 footer_lxwm_left">著作权与商标声明</span>
                </a>
                <a class="xuanzhong wenzi" href="">
                  <span class="footer_text2 footer_lxwm_left">隐私政策</span>
                </a>
              </div>
              <div class="glzy_bottom">
                <span class="footer_text2 ">
                  Copyright@2020 海粟智链（青岛）科技有限公司
                  版权所有鲁ICP备 19060515号-1</span>
              </div>
            </div>
          </el-col>
        </el-row>
      </el-footer>
    </el-container>
  </div>
</template>
<script>
    import {regionDataPlus, CodeToText} from "element-china-area-data"
    import QRCode from "qrcodejs2";

    export default {
        name: 'balance',
        data: function () {
            return {
                is_open: {
                    sousuo: 1,
                    lanmu: 1,
                },
                password: '',
                fukuan_shijian: false,
                radio: '1',
                textarea: '',
                options: regionDataPlus,
                diqu: '',
                xiangxi: '',
                list: '',
                shuliang: '',
                zfb_url: '',
                url: '',
                aid: '',
                order_id: '',
                pay_status: '',
                list_xinxi: '',
                btndisabled: true,
            }
        },
        methods: {
            init() {
                this.aid = localStorage.getItem("uid")
                this.url = window.config.api_url
                var t = this
                t.order_id = t.$route.params.id
                if (t.$route.params.id) {
                    // t.api_data()
                    this.qrCode()
                    this.xinxi()
                }
            },
            balance_payment() {
                var t = this;
                var token = localStorage.getItem('token');
                var id = t.list_xinxi.id;
                var password = t.password;
                var url = window.config.api_url + '/user/goods/order/balance/pay';
                // var formData = new FormData();
                // formData.append('token', token);
                // formData.append('order_id', id);
                // formData.append('pay_password',t.password);
                t.axios.get(url, {
                    params: {
                        token: token,
                        order_id: id,
                        pay_password: password,
                    }
                }).then(res => {
                    if (res.data.status == 0) {
                        t.$message({
                            showClose: true,
                            message: res.data.description?res.data.description:'成功',
                            type: 'success'
                        });
                        t.btndisabled = false;
                    }
                    if (res.data.status == 1) {
                        this.$message({
                            showClose: true,
                            message: res.data.description,
                            type: 'error'
                        });
                    }

                })
            },
            xinxi() {
                var t = this
                var id = localStorage.getItem('uid');
                console.log(id);
                var url = window.config.api_url + '/user/goods/order/' + t.$route.params.id + '?token=' + id
                t.axios.get(url).then(res => {
                    if (res.data.status) {
                        t.$code(res.data.status)
                    }
                    // console.log(res,999)
                    t.list_xinxi = res.data.order
                    // console.log(res.data.order)
                })
            },
            qrCode() {
                var wx_url = ''
                var t = this
                var id = localStorage.getItem("uid")
                var url = window.config.api_url + '/user/goods/order/wechatPay?token=' + id + '&order_id=' + t.$route.params.id
                t.axios.get(url).then(res => {
                    console.log(res.data)
                    if (res.data.code_url) {
                        wx_url = res.data.code_url
                        t.erweima(wx_url)
                    }
                })

            },
            erweima(wx_url) {
                this.dialogVisible = true;
                // console.log(this.radio,this.radio1)
                var qrcode = ''
                console.log(qrcode)
                this.$nextTick(function () {
                    document.getElementById("qrcode").innerHTML = "";
                    qrcode = new QRCode("qrcode", {
                        width: 432,
                        height: 432,
                        text: wx_url,
                        colorDark: "#000000",
                        colorLight: "#ffffff"
                    });
                });
            },
            api_data() {
                this.shuliang = this.$store.state.pathName
                var t = this
                var id = localStorage.getItem("uid")
                var url = window.config.api_url + '/user/goods/order/' + t.$route.params.id + '?token=' + id
                t.axios.get(url).then(res => {
                    // console.log(res.data)
                    t.pay_status = res.data.order.pay_status
                    if (res.data.order.pay_status != 1) {
                        t.open4()
                    }
                })
            },
            open4() {
                this.$message.error('付款失败');
            },
            sousuo_xuanxiang(e) {
                this.is_open.sousuo = e
                // console.log(this.is_open.sousuo)
            },
            handleChange() {
                // console.log(CodeToText[e[0]])
                // console.log(CodeToText[e[1]])
            },
            click() {
                // 点击按钮进行一些操作，然后保存数据
                this.$store.commit('saveCurrDbSource', 2)
                console.log(
                    this.$store.state.currDbSource)
            },
            posy() {
                var t = this
                var url = window.config.api_url + '/user/goodsOrder/create'
                var formData = new FormData();
                var id = 'deTqiWkXIJSUn1OLRkV5jmHTCIjtR3JpTnAyKjcsZ3jUEq9XXonVruQ6pCR3'
                // localStorage.getItem("uid")
                formData.append('token', id);
                formData.append('detail_address', t.xiangxi);
                formData.append('note', t.textarea);
                formData.append('province_code', t.diqu[0]);//省代码
                formData.append('province', CodeToText[t.diqu[0]]);
                formData.append('city_code', t.diqu[1]);//市代码
                formData.append('city', CodeToText[t.diqu[1]]);
                formData.append('area_code', t.diqu[2]);//区代码
                formData.append('area', CodeToText[t.diqu[2]]);
                formData.append('goods[0][goods_id]', 95);
                formData.append('goods[0][number]', 1);
                t.axios.post(url, formData).then(res => {
                    console.log(res)
                })
            }

        },
        created() {
            this.init()
            // console.log(CodeToText[110101],110101)
        }
    }
</script>
<style lang="less">
  #qrcode {
    .img {
      width: 432px;
      height: 432px;
    }
  }
</style>
<style lang="less" scoped>
  @import "../../../../node_modules/element-ui/lib/theme-chalk/display.css";
  //@head_text : Source Han Sans CN;
  @font-face {

  }

  @import "../../../assets/css/home";
  .el-footer {
    background-color: #FFFFFF;
    color: #333;
    //text-align: center;
    padding: 0 0;
    //line-height: 60px;
  }

  .el-main {
    background-color: #FFFFFF;
    color: #333;
    //text-align: center;
    padding: 0 0;
    //line-height: 500px;
  }

  .el-header {
    background: #FFFFFF;
    padding: 0 0;
    //border-bottom: #4E6EF2 solid 3px;
  }

  #app {
    width: 100%;

    .header {
      height: 100%;
      width: 80%;
      max-width: 1200px;
      margin-right: auto;
      margin-left: auto;

      .header_logo {
        margin-top: 50px;
      }
    }

    .main {
      height: 100%;
      width: 80%;
      //height: 200px;
      max-width: 1200px;
      margin-bottom: 122px;
      margin-right: auto;
      margin-left: auto;

      .main_corlo {
        width: 100%;
        height: 169px;
        background: #EBF2F9;
        border-radius: 10px;
        float: left;
      }

      .main_shangpin {

        height: 86px;
        position: relative;
        background: #EBF2F9;
        margin-top: 45px;

        .main_shangpin_img {
          width: 85px;
          height: 85px;
          background: #FFFFFF;
          border: 1px solid #E1E1E1;
          margin-left: 40px;
        }

        .shanpin_bianhao {
          position: absolute;
          margin-left: 20px;
          //width: 209px;
          //height: 14px;
          font-size: 14px;
          font-family: Source Han Sans CN;
          font-weight: 400;
          color: #333333;
          //line-height: 100px;
        }

        .shanpin_name {
          margin-left: 20px;
          position: absolute;
          margin-top: 28px;
          font-size: 14px;
          font-family: Source Han Sans CN;
          font-weight: 400;
          color: #333333;
        }

        .shanpin_jine {
          margin-right: 40px;
          //width: 175px;
          //height: 36px;
          font-size: 36px;
          font-family: Source Han Sans CN;
          font-weight: bold;
          color: #EF4F3F;
          //line-height: 100px;
          float: right;
        }

        .shangpin_daojishi {
          //width: 182px;
          //height: 14px;
          font-size: 14px;
          font-family: Source Han Sans CN;
          font-weight: 500;
          color: #333333;
          float: right;
          //width: 70%;
          //line-height: 100px;
        }

        .shangpin_daojishi2 {
          color: #EF4F3F;
        }
      }

      .main_biaoti {
        width: 100%;
        float: left;
        margin-top: 80px;
        text-align: center;
        //width: 211px;
        //height: 34px;
        font-size: 32px;
        font-family: Source Han Sans CN;
        font-weight: 500;
        color: #333333;
        //line-height: 18px;
      }

      .main_jine {
        margin-top: 21px;
        text-align: center;
        //width: 175px;
        //height: 36px;
        font-size: 46px;
        font-family: Source Han Sans CN;
        font-weight: bold;
        color: #EF4F3F;
        //line-height: 100px;
      }
    }

    .footer {
      width: 100%;
      height: 255px;
      background: #FFFFFF;
      border-bottom: #E1E1E1 solid 1px;

      .footer_width {
        width: 80%;
        max-width: 1200px;
        margin-right: auto;
        margin-left: auto;

        .xdsk_top {
          position: relative;
          margin-top: 70px;

          .footer_img_xinshou {
            //margin-left: 5px;
            //margin-top: 13px;
            position: absolute;
            width: 50px;
            height: 50px;
          }

          .footer_img_duiwai {
            //margin-left: 155px;
            //margin-top: 13px;
            //margin-top: 13px;
            position: absolute;
            width: 50px;
            height: 50px;
          }

          .footer_img_shiming {
            //margin-left: 155px;
            //margin-top: 13px;
            position: absolute;
            width: 50px;
            height: 50px;
          }

          .footer_img_kefu {
            //margin-left: 155px;
            //margin-top: 13px;
            position: absolute;
            width: 50px;
            height: 50px;
          }

          .footer_xinshou_left {
            margin-left: 60px;
          }

          .footer_dsk_left {
            margin-left: 60px;
          }
        }

        .xdsk_bottom {
          margin-top: 38px;

          .footer_kongjian_left {
            margin-left: 17px;
          }

          .footer_jiaoyi_left {
            margin-left: 184px;
          }

          .footer_shiming_left {
          }

          .footer_tousu_left {
            margin-left: 520px;
          }

          .footer_changjian_left {
            margin-left: 945px;
          }
        }

        .glzy_top {
          margin-top: 51px;

          .footer_gyyyj_left {
            padding-right: 20px;
            border-right: #E1E1E1 solid 1px;
          }

          .footer_lxwm_left {
            margin-left: 29px;
            padding-right: 21px;
            border-right: #E1E1E1 solid 1px;
          }
        }

        .glzy_bottom {
          margin-top: 45px;
        }
      }
    }

    .footer_bottom {
      border-bottom: none;
      height: 223px;
    }
  }

  .youfudong {
    float: right;
  }

  .main_text {
    //width: 69px;
    //height: 14px;
    font-size: 14px;
    font-family: Source Han Sans CN;
    font-weight: 500;
    color: #666666;
    //line-height: 100px;
  }

  .main_text1 {
    //width: 108px;
    //height: 12px;
    font-size: 12px;
    font-family: Source Han Sans CN;
    font-weight: 500;
    color: #333333;
    //line-height: 100px;
  }

  .head_text {
    font-size: 14px;
    font-family: Source Han Sans CN;
    font-weight: 550;
    color: #333333;
    line-height: 38px;
  }

  .footer_text1 {
    font-size: 16px;
    font-family: Source Han Sans CN;
    font-weight: 150;
    color: #666666;
    //line-height: 30px;
  }

  .footer_text2 {
    font-size: 16px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #666666;
    //line-height: 30px;
  }

  .footer_text3 {
    font-size: 30px;
    font-family: Source Han Sans CN;
    font-weight: 550;
    color: #333333;
    //line-height: 30px;
  }

  .xuanzhong:hover {
    //color:#4E6EF2;
    text-decoration: none;
  }

  .wenzi {
    text-decoration: none;
  }

  .btnstyle1 {
       display:inline-block;
       width: 150px;
       right: 150px;
       margin-top: 10px;
       margin-left: 5px;
     }
  .btnstyle2 {
    display:inline-block;
    width: 150px;
    right: 150px;
    margin-top: 10px;
    margin-left: 80%;
  }
  .inputStyle{
    display: inline-block;
    width: 250px;
    margin-top: 10px;
    margin-left:55%;

  }
  /*.btnstyle2 {*/
  /*  position: absolute;*/
  /*  width: 150px;*/
  /*  right: 150px;*/
  /*  top: 400px;*/
  /*}*/
</style>